// OrderDetails.jsx
import React, { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaTruck, FaCalendarAlt, FaClock, FaReceipt, FaPlus, FaChevronRight, FaBoxOpen } from "react-icons/fa";
import { HiCurrencyRupee } from "react-icons/hi";
import { FiChevronRight } from "react-icons/fi";
import InvoiceModal from "./InvoiceModal"; // adjust path if needed
import HeaderBar from '../Component/Header2';
import BuildCoin from '../images/buildcoin.png';
import Building from '../images/Building1.png';
import Map from '../images/Map.png';
import { useNotification } from '../../context/NotificationContext';
import CustomPopup from "./CustomPopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage } from "@fortawesome/free-solid-svg-icons";

const formatINR = (n) => {
  if (n == null || isNaN(n)) return "₹0";
  return "₹" + Number(n).toLocaleString("en-IN");
};

const getDayLabel = (isoDate) => {
  if (!isoDate) return "";
  const dd = new Date(isoDate);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const dt = new Date(dd);
  dt.setHours(0, 0, 0, 0);
  const diffDays = Math.round((dt - today) / (1000 * 60 * 60 * 24));
  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "Tomorrow";
  return dd.toLocaleDateString("en-US", { weekday: "long" }); // Saturday, Monday etc.
};

const OrderDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const paramsOrderId = location.state?.orderId || new URLSearchParams(location.search).get("order_id");
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [invoiceOpen, setInvoiceOpen] = useState(false);
  const [deliveryAddress, setDeliveryAddress] = useState(null); 
   const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
    const { notifications, setNotifications } = useNotification();
    const [popup, setPopup] = useState({
  open: false,
  title: "",
  message: "",
  type: "info",
});

const showPopup = (title, message, type = "info") => {
  setPopup({ open: true, title, message, type });
};

  useEffect(() => {
    if (!paramsOrderId) {
      console.warn("No order id provided in route state or query");
      setLoading(false);
      return;
    }
    fetchOrder(paramsOrderId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramsOrderId]);

    useEffect(()=>{
        if(notifications && notifications.length > 0 && paramsOrderId){     
         fetchOrder(paramsOrderId);
       }
      },[notifications, paramsOrderId]);

  const fetchOrder = async (orderId) => {
    try {
      setLoading(true);
      // Endpoint - adjust if your backend route differs.
      const endpoint = `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/salesorder/get-customer-order-by-orderId?order_id=${orderId}`;
      const r = await fetch(endpoint, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      const payload = await r.json();
      console.log("Fetched order payload:", payload);
      if (payload?.success && payload?.data) {
        setOrder(payload.data);
         await fetchDeliveryAddress(payload.data.delivery_address_id);
      } else {
        console.error("Failed loading order:", payload);
        setOrder(null);
      }
    } catch (err) {
      console.error("Error fetching order:", err);
      setOrder(null);
    } finally {
      setLoading(false);
    }
  };

    const fetchDeliveryAddress = async (addressId) => {
  try {
    const token = sessionStorage.getItem('token');

    const response = await fetch(`${fetchUrl}customer/delivery-address/getDeliveryAddressById?address_id=${addressId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
    });

    const data = await response.json();    
    if (data.success) {
      setDeliveryAddress(data.data);
      console.log(' Delivery Address Set:', data.data);
    } else {
      console.error(' Failed to fetch delivery address:', data.message);
    }
  } catch (error) {
    console.error(' Error fetching delivery address:', error);
  }
 
};

 const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);

  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const [invoicePreviewOpen, setInvoicePreviewOpen] = useState(false);
const [invoiceFiles, setInvoiceFiles] = useState([]);

const downloadInvoice = async () => {
  try {
    const token = sessionStorage.getItem("token");
    const endpoint = `${process.env.REACT_APP_FORE_BRICKBUCKET}invoice/get-all-invoices-by-order-id?order_id=${order_id}`;

    const res = await fetch(endpoint, {
      method: "GET",
      headers: { "Content-Type": "application/json", "x-token": token },
    });

    const json = await res.json();

    if (!json?.data || json.data.length === 0) {
      showPopup("No Invoice Found", "There are no invoices available for this order.", "error");
      return;
    }

    // Extract file URLs
    const invoiceFilesArr = [];
    json.data.forEach((inv) => {
      (inv.files || []).forEach((file) => {
        const url = file.startsWith("http")
          ? file
          : `${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${file}`;
        invoiceFilesArr.push(url);
      });
    });

    if (invoiceFilesArr.length === 0) {
      showPopup("No Invoice Files", "Invoice exists but contains no downloadable files.", "info");
      return;
    }

    // OPEN PREVIEW MODAL
    setInvoiceFiles(invoiceFilesArr);
    setInvoicePreviewOpen(true);

  } catch (err) {
    console.error(err);
    showPopup("Download Failed", "Something went wrong while getting invoices.", "error");
  }
};


/* const downloadInvoice = async () => {
  try {
    const token = sessionStorage.getItem("token");
    const endpoint = `${process.env.REACT_APP_FORE_BRICKBUCKET}invoice/get-all-invoices-by-order-id?order_id=${order_id}`;

    const res = await fetch(endpoint, {
      method: "GET",
      headers: { 
        "Content-Type": "application/json",
        "x-token": token 
      },
    });

    const json = await res.json();
    
    if (!json?.data || json.data.length === 0) {
      showPopup("No Invoice Found", "There are no invoices available for this order.", "error");
      return;
    }

   //console.log("Invoices to download:", json);
    const invoices = json.data;

    let downloadCount = 0;

    invoices.forEach((inv) => {
      (inv.files || []).forEach((filePath) => {
        const fileUrl = filePath.startsWith("http")
          ? filePath
          : `${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${filePath}`;

        const fileName = filePath.split("/").pop();

        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();

        window.open(fileUrl, "_blank");

        downloadCount++;
      });
    });

    showPopup(
      "Invoice Downloaded",
      `${downloadCount} file(s) downloaded successfully.`,
      "success"
    );

  } catch (error) {
    console.error(error);
    showPopup("Download Failed", "Something went wrong while downloading invoices.", "error");
  }
}; */

const getStatusBadge = (status = "") => {
  switch (status.toLowerCase()) {
    case "delivery group created":
      return "bg-red-100 text-red-700";
    case "confirmed":
    case "accepted":
      return "bg-blue-100 text-blue-700";
    case "out for delivery":
      return "bg-purple-100 text-purple-700";
    case "delivered":
      return "bg-green-100 text-green-700";
    case "cancelled":
    case "rejected":
      return "bg-red-100 text-red-700";
    default:
      return "bg-gray-100 text-gray-600";
  }
};


  const sortedDeliveryGroups = useMemo(() => {
    if (!order?.delivery_groups) return [];
    // Sort by delivery_date desc (latest first). If no date, keep at end.
    return [...order.delivery_groups].sort((a, b) => {
      const da = a.delivery_date ? new Date(a.delivery_date).getTime() : 0;
      const db = b.delivery_date ? new Date(b.delivery_date).getTime() : 0;
      return db - da;
    });
  }, [order]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-gray-500">Loading order...</div>
      </div>
    );
  }

  if (!order) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
        <div className="max-w-lg text-center">
          <h3 className="text-lg font-semibold text-gray-800">Order not found</h3>
          <p className="text-sm text-gray-500 mt-2">The requested order is not available.</p>
          <button
            onClick={() => navigate(-1)}
            className="mt-4 px-4 py-2 bg-red-600 text-white rounded-lg"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  const {
    order_id,
    order_number,
    order_date,
    subtotal,
    tax_amount,
    total,
    discount,
    earned_build_coins,
    product_categories,
    items_count,
    status,
    payment_status,
    delivery_charges
  } = order;

  return (
    <div className="min-h-screen bg-gray-100 pb-20">
        {/* HEADER BAR */}
      <div className="mb-4 sticky top-0 z-30 bg-white border-b">
        <HeaderBar
          title="Order Details"
          showSearch={false}
        />
      </div>

      {/* Page body */}
      <div className="max-w-4xl mx-auto px-4 mt-4">
        
        {/* ORDER HEADER CARD */}
<div className="bg-white rounded-2xl shadow-sm border p-4 mb-4">

  {/* Top: Order Number + Date */}
  <div className="flex items-center justify-between mb-3">
    <div>
      <div className="text-lg font-bold text-gray-900">{order_number}</div>

      {/* Status */}
      <div
        className={`text-xs font-semibold mt-1 inline-block px-2 py-1 rounded-full
          ${status === "Confirmed"
            ? "bg-green-50 text-green-700 border border-green-200"
            : status === "Shipped"
            ? "bg-blue-50 text-blue-700 border border-blue-200"
            : "bg-gray-50 text-gray-600 border border-gray-200"
          }`}
      >
        {status}
      </div>
    </div>

   {/* Order Date */}
<div className="text-right">
  <div className="text-[10px] text-gray-500 uppercase tracking-wide mb-0.5">
    Order Date
  </div>

  <div className="text-xs text-gray-700 leading-tight">
    {order_date ? new Date(order_date).toLocaleString() : "—"}
  </div>
</div>

  </div>

  {/* Bottom Bar: Items summary */}
<div className="mt-2 border-t pt-3 flex items-center justify-between">

  {/* LEFT — ITEMS COUNT */}
  <div className="flex items-center gap-2 text-sm text-gray-600">
    <FaBoxOpen className="h-4 w-4 text-gray-400" />
    <span className="font-medium">{items_count || 0} items</span>
  </div>

  {/* RIGHT — EARNED BUILD COINS */}
  {earned_build_coins > 0 && (
    <div className="flex items-center gap-1 text-sm font-semibold text-yellow-600">
      <img
        src={BuildCoin}
        alt="Coin"
        className="h-4 w-4 object-contain"
      />
      <span>+{earned_build_coins} Build Coins earned</span>
    </div>
  )}
</div>


</div>

       
{/* DELIVERY GROUPS */}
<div className="flex flex-col gap-4">
  {sortedDeliveryGroups.map((dg) => (
    <div
      key={dg.delivery_group_id}
      className="bg-white rounded-xl border py-4 shadow-sm relative"
    >

       <div
        className={`absolute top-3 right-3 px-3 py-1 rounded-full text-xs font-semibold capitalize
        ${getStatusBadge(dg.delivery_group_status)}`}
      >
        {dg.delivery_group_status}
      </div>

      {/* SECTION HEADER */}
   <div className="mb-4 mt-8 px-3">

  {/* ROW 1 — TRUCK + SLOT/DATE */}
  <div className="flex items-start gap-3">

    {/* TRUCK ICON */}
    <div className="p-2 bg-red-50 rounded-md">
      <FaTruck className="h-5 w-5 text-red-600" />
    </div>

    {/* SLOT + DATE */}
    <div className="flex flex-col gap-1 text-xs">
      <div className="flex items-center gap-1">
        <FaClock className="h-3 w-3 text-gray-400" />
        <span>{dg.delivery_slot || "Slot not set"}</span>
      </div>

      <div className="flex items-center gap-1">
        <FaCalendarAlt className="h-3 w-3 text-gray-400" />
        <span>{getDayLabel(dg.delivery_date)}</span>
        <span>•</span>
        <span>{formatDate(dg.delivery_date)}</span>
      </div>
    </div>
  </div>

  {/* ROW 2 — DELIVERY OTP */}
  {dg.order_delivered_otp && (
  <div className="mt-3 mx-0">
    {/* OTP BLOCK */}
    <div className="bg-white rounded-xl px-3  py-3 border border-gray-200 shadow-sm w-full">
      <div className="flex items-center gap-4">

        <div>
          <p className="text-gray-900 font-semibold text-[14px] leading-tight">
            Delivery Verification
          </p>
          <p className="text-gray-500 text-[10px] whitespace-nowrap">
            Share this OTP with the delivery executive
          </p>
        </div>

        <div className="bg-gray-50 rounded-lg h-8 px-4 border border-gray-300 min-w-[76px] flex items-center justify-center">
          <p className="text-[14px] font-bold text-gray-900 tracking-widest">
            {dg.order_delivered_otp}
          </p>
        </div>

      </div>
    </div>
    
  </div>
  )}

</div>


      {/* CATEGORIES */}
      <div className="flex flex-col gap-3">
        {dg.delivery_categories.map((cat) => (
          <div key={cat.product_category_id} className="border rounded-sm p-3 bg-gray-50">
            
            {/* CATEGORY HEADER */}
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-3">
                {/* <div className="w-9 h-9 rounded-md bg-white flex items-center justify-center border">
                  <svg className="h-4 w-4 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M3 3h18v18H3z" />
                  </svg>
                </div> */}

                <div>
                  <div className="text-sm font-semibold text-gray-800">
                    {cat.product_category_name}
                  </div>
                  <div className="text-xs text-gray-500">
                    {cat.items.length} items
                  </div>
                </div>
              </div>
            </div>

            {/* ITEMS */}
            <div className="grid gap-3">
              {cat.items.map((it) => (
                <div key={it.item_id} className="flex items-center gap-3 bg-white p-2 rounded-lg border">
                  
                  {/* IMAGE */}
                  <div className="w-14 h-14 rounded-lg bg-gray-50 overflow-hidden border flex items-center justify-center p-1">
                   {it.item_image ? (
                   <img
                   src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${it.item_image}`}
                   alt={it.item_name}
                   className="object-cover w-full h-full"
                  />
                  ) : (
                  <FontAwesomeIcon icon={faImage} className="text-gray-400 text-2xl" />
                  )}
                  </div>

                  {/* DETAILS */}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between">
                      <div className="text-sm font-medium text-gray-900 line-clamp-1">
                        {it.item_name}
                      </div>
                      <div className="text-sm font-bold text-gray-900">
                        {formatINR(it.total)}
                      </div>
                    </div>

                    <div className="text-xs text-gray-500 flex items-center gap-4 mt-1">
                      <div>
                         {formatINR(it.selling_price)} × {it.quantity} {it.UOM || "Qty"}

                      </div>

                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

    {/* DELIVERY SLOT & TRACKING FOOTER */}
<div className=" flex items-end justify-end  pt-3 px-3">

  {/* LEFT SECTION — DELIVERY ICON + SLOT + DATE */}
  {/* <div className="flex items-start gap-2 text-xs text-gray-600">

    <div className="p-1 bg-red-50 rounded-md flex items-center justify-center">
      <FaTruck className="h-4 w-4 text-red-600" />
    </div>

    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-1">
        <FaClock className="h-3 w-3 text-gray-400" />
        <span>{dg.delivery_slot || "Slot not set"}</span>
      </div>

      <div className="flex items-center gap-1">
        <FaCalendarAlt className="h-3 w-3 text-gray-400" />
        <span>{getDayLabel(dg.delivery_date)}</span>
        <span>•</span>
        <span>{formatDate(dg.delivery_date)}</span>
      </div>
    </div>
  </div> */}

  {/* TRACK ITEMS BUTTON */}
  <button
    className="text-blue-600 text-sm font-semibold flex items-center gap-1"
    // onClick={() => handleTrackItems(dg.delivery_group_id)}
  >
    Track Items
    <FaChevronRight className="h-3 w-3" />
  </button>
</div>

    </div>
  ))}
</div>


      {/* Totals panel */}
<div className="bg-white rounded-xl border p-4 mt-6 shadow-sm">

  {/* Subtotal */}
  <div className="flex items-center justify-between mb-2">
    <div className="text-sm text-gray-600">Subtotal</div>
    <div className="text-sm font-semibold text-gray-900">{formatINR(subtotal)}</div>
  </div>

  {/* BuildCoins Used */}
  {discount > 0 ?( 
    <>
    <div className="flex items-center justify-between mb-2">
    <div className="text-sm text-gray-600">BuildCoins Discount</div>
    <div className="text-sm font-semibold text-green-600">-{formatINR(discount)}</div>
    </div>
    </>):(
      <>

      </>
    )}
 

  {/* Tax */}
  <div className="flex items-center justify-between mb-2">
    <div className="text-sm text-gray-600">Tax</div>
    <div className="text-sm font-semibold text-gray-900">{formatINR(tax_amount)}</div>
  </div>
  {/* delivery Charges */}
  {delivery_charges > 0 ? (
    <div className="flex items-center justify-between mb-2">
    <div className="text-sm text-gray-600">Delivery Charges</div>
    <div className="text-sm font-semibold text-gray-900">{formatINR(delivery_charges)}</div>
  </div>
  ):(
    <></>
  )}

  {/* Grand Total */}
  <div className="border-t mt-3 pt-3 flex items-center justify-between">
    <div className="text-base font-semibold text-gray-900 flex items-center gap-2">
      {/* <HiCurrencyRupee className="h-5 w-5 text-gray-700" /> */}
      Grand Total
    </div>
    <div className="text-lg font-bold text-gray-900">{formatINR(total)}</div>
  </div>

  {/* Footer: View Invoice + Share */}
  <div className="mt-4 flex items-center justify-between">

    {/* View Invoice Link */}
    {/* <button
      onClick={() => setInvoiceOpen(true)}
      className="text-blue-600 text-sm font-semibold underline underline-offset-4 decoration-dotted"
    >
      View Invoice
    </button> */}
    <button
  onClick={downloadInvoice}
  className="text-blue-600 underline underline-offset-2 decoration-dotted text-sm font-medium"
>
  View Invoice
</button>


    {/* Share Button */}
    <button
      onClick={() => {
        navigator.share
          ? navigator.share({
              title: "Order Details",
              text: `Order ${order_number}`,
              url: window.location.href,
            })
          : alert("Share is not supported on this device");
      }}
      className="text-gray-700 text-sm font-medium px-3 py-1 border rounded-lg bg-gray-50"
    >
      Share
    </button>
  </div>

</div>


{/* DELIVERY LOCATION SECTION */}
<div className=" mt-4">
  <div className="bg-white rounded-xl shadow-sm border">
    <div className="flex items-start gap-3 p-4">

      {/* LOCATION ICON */}
      <div className="flex-shrink-0">
        {deliveryAddress?.address_type === "project" ? (
          <img
            src={Building}
            alt="Project"
            className="h-10 w-10 object-contain"
          />
        ) : (
          <img
            src={Map}
            alt="Address"
            className="h-8 w-8 object-contain"
          />
        )}
      </div>

      {/* ADDRESS DETAILS */}
      <div className="flex-1 min-w-0">
        {deliveryAddress ? (
          <>
            {/* DELIVERY TEXT */}
            <p className="text-sm font-medium text-gray-900">
              {order && order.status === "Delivered" ? "Delivered to " : "Delivering to "}
              <span className="font-semibold text-gray-900">
                {deliveryAddress.address_type === "project"
                  ? "Project"
                  : "Address"}
              </span>
            </p>

            {/* MAIN ADDRESS LINE */}
            <p className="text-xs text-gray-700 truncate mt-1">
              {deliveryAddress.address_type === "project"
                ? `${deliveryAddress.project_name}${
                    deliveryAddress.area_sector_locality
                      ? ", " + deliveryAddress.area_sector_locality
                      : ""
                  }`
                : deliveryAddress.area_sector_locality || "No address available"}
            </p>

            {/* SECONDARY ADDRESS IF EXISTS */}
            {deliveryAddress.full_address && (
              <p className="text-[11px] text-gray-500 mt-1 line-clamp-2">
                {deliveryAddress.full_address}
              </p>
            )}
          </>
        ) : (
          <p className="text-sm text-gray-700">No delivery address</p>
        )}
      </div>

    </div>
  </div>
</div>



      </div>

      <CustomPopup
  open={popup.open}
  title={popup.title}
  message={popup.message}
  type={popup.type}
  onClose={() => setPopup({ ...popup, open: false })}
/>


      {/* Invoice modal */}
      <InvoiceModal
       open={invoicePreviewOpen}
        files={invoiceFiles}
        onClose={() => setInvoicePreviewOpen(false)}
      />

   

    </div>
  );
};

export default OrderDetails;
